// extracted by mini-css-extract-plugin
module.exports = {"Layout":"OKACa","Layout_Main":"K1s8J"};